import {
  DeleteOutlined,
  EditOutlined,
  ScheduleOutlined,
  SettingOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Popover,
  Radio,
  Row,
  Space,
  Switch,
  Tag,
  Tooltip,
  Typography,
  message
} from 'antd';
import moment from 'moment';
import React, { useContext, useRef, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import CurrencyInputCustom from '../../components/CurrencyInputCustom';
import CustomDatePicker from '../../components/CustomDatePicker';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import TableAndFilters from '../../components/TableAndFilters';
import { CONFIG } from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import { currencyToNumber, errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import AseguradoraProductos from './componentes/AseguradoraProductosSelect';

const { Text } = Typography;

function AseguradoraProducto() {
  const [productoId, setProductoId] = useState();
  const [visible, setVisible] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [update, setUpdate] = useState(false);
  const [data, setData] = useState([]);
  const [activo, setActivo] = useState(true);
  const [publico, setPublico] = useState(true);
  const [buttonstate, setButtonstate] = useState(false);
  const [buttontext, setButtontext] = useState('Asignar');
  const [titlemodal, setTitlemodal] = useState('Configuracion de Producto');
  const monedaGs = { codigo: 'gs', simbolo: 'Gs.' };
  const monedaUsd = { codigo: 'usd', simbolo: 'USD.' };
  const [form] = Form.useForm();
  const [formAseguradora] = Form.useForm();
  const tableRef = useRef();
  const { cargar } = useContext(EmpresaContext);
  const history = useHistory();
  const [loading, setLoading] = useState();

  const {
    params: { id: aseguradoraId }
  } = useRouteMatch();
  const url = `/aseguradoraproducto/${aseguradoraId}`;
  const styles = {
    form: { textAlign: 'left' },
    card: { marginBottom: 10, textAlign: 'left' }
  };

  // const ESTADOS_PRODUCTO = {
  //   INACTIVO: 'Inactivo',
  //   ACTIVO: 'Activo'
  // };
  const columns = [
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion'],
      width: '25%'
    },
    {
      title: 'Fecha de Inicio',
      dataIndex: 'fecha_inicio',
      width: '15%'
    },
    {
      title: 'Fecha de Fin',
      dataIndex: 'fecha_fin',
      width: '15%'
    },
    {
      title: 'Link de condiciones',
      dataIndex: ['link_condiciones'],
      width: '30%'
    },
    {
      title: 'Condiciones',
      dataIndex: 'condiciones',
      render: (condiciones) => {
        if (condiciones) {
          return (
            <Popover content={condiciones} title="Condiciones">
              <Text
                style={{
                  width: 100
                }}
                ellipsis
              >
                {condiciones}
              </Text>
            </Popover>
          );
        }
        return null;
      }
    },
    {
      title: 'Costo sevicio %',
      dataIndex: 'costo_servicio_porcentaje'
    },
    {
      title: 'Uso',
      dataIndex: ['publico'],
      render: (ispublico) => {
        let uso;
        let color;
        if (ispublico) {
          color = CONFIG.COLOR_PRIMARY;
          uso = 'Público';
        } else {
          color = 'gray';
          uso = 'Interno';
        }
        return (
          <Tag color={color} key={uso}>
            {uso}
          </Tag>
        );
      },
      width: '10%'
    },

    {
      title: 'Activo',
      dataIndex: 'activo',
      render: (thisestado) => {
        let estadoUpperCase;
        let color = 'white';
        if (thisestado) {
          color = 'green';
          estadoUpperCase = 'ACTIVO';
        } else {
          color = 'orange';
          estadoUpperCase = 'INACTIVO';
        }
        return (
          <Tag color={color} key={estadoUpperCase}>
            {estadoUpperCase}
          </Tag>
        );
      },
      // filterType: fieldTypes.ENUM,
      // filters: Object.keys(ESTADOS_PRODUCTO).map((key) => ({
      //   text: ESTADOS_PRODUCTO[key],
      //   value: key
      // })),
      // sortable: true,
      width: '10%'
    },
    {
      title: 'Acciones',
      key: 'action',
      align: 'left',
      width: '10px',
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="middle"
              onClick={() => updateProducto(record)}
            />
          </Tooltip>
          <Tooltip title="Configurar Vigencia">
            <Button
              type="text"
              icon={<ScheduleOutlined />}
              size="middle"
              onClick={() => configurarVigencia(record)}
            />
          </Tooltip>
          <Tooltip title="Configurar Coberturas">
            <Button
              type="text"
              icon={<SettingOutlined />}
              size="middle"
              onClick={() => configurarCoberturas(record)}
            />
          </Tooltip>
          <Tooltip title="Eliminar">
            <Button
              type="text"
              icon={<DeleteOutlined />}
              size="middle"
              onClick={() => deleteproducto(record)}
            />
          </Tooltip>
        </Space>
      )
    }
  ];

  const configurarVigencia = (record) => {
    history.push(`/aseguradoraproducto/vigencia/config/${record.id}`);
  };

  const configurarCoberturas = (record) => {
    history.push(`/aseguradoraproducto/cobertura/${record.id}`);
  };
  const handleOk = async () => {
    const newValues = {
      ...form.getFieldValue()
    };
    try {
      setLoading(true);
      if (update) {
        await instanceRef.instance.post(
          `aseguradoraproducto/update/${data.id}`,
          {
            ...newValues,
            fecha_inicio: newValues.fecha_inicio
              ? moment(newValues.fecha_inicio)
              : null,
            fecha_fin: newValues.fecha_fin ? moment(newValues.fecha_fin) : null,
            activo,
            publico
          }
        );
        cargar(true);
        setVisible(false);
        setUpdate(false);
        form.resetFields();
        setData(null);
      } else {
        await instanceRef.instance.post(`aseguradoraproducto/add`, {
          id_aseguradora: aseguradoraId,
          id_producto: productoId,
          ...newValues,
          fecha_inicio: newValues.fecha_inicio
            ? moment(newValues.fecha_inicio)
            : null,
          fecha_fin: newValues.fecha_fin ? moment(newValues.fecha_fin) : null,
          activo,
          publico
        });
        cargar(true);
        setUpdate(false);
        setVisible(false);
      }
      setLoading(false);
      tableRef.current.reload();
    } catch (err) {
      errorHandler(err, 'Error al enviar');
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setUpdate(false);
    setVisible(false);
    form.resetFields();
  };

  const checkDate = () => {
    if (form.getFieldValue('fecha_inicio') === null) {
      setButtonstate(false);
      return Promise.resolve();
    }
    if (form.getFieldValue('fecha_fin') === null) {
      setButtonstate(false);
      return Promise.resolve();
    }
    if (form.getFieldValue('fecha_inicio') > form.getFieldValue('fecha_fin')) {
      setButtonstate(true);
      return Promise.reject(
        new Error('El fin de vigencia tiene que ser posterior al del incio')
      );
    }
    setButtonstate(false);
    return Promise.resolve();
  };

  const handleActivo = async (value) => {
    setActivo(value);
  };

  const handlePublico = (value) => {
    setPublico(value);
  };

  const deleteproducto = async (record) => {
    const idproducto = record.id_producto;
    const idaseguradora = record.id_aseguradora;
    try {
      const response = await instanceRef.instance.post(
        `aseguradoraempresaproducto/searchproducto`,
        {
          id_aseguradora: idaseguradora,
          id_producto: idproducto
        }
      );
      if (response.data.data.length > 0) {
        message.warning(
          'No se puede eliminar el producto, ya esta asociado a una empresa.'
        );
      } else {
        const idap = record.id;
        await instanceRef.instance.post(`aseguradoraproducto/delete`, {
          id: idap
        });
        message.warning('Se ha eliminado el producto del la aseguradora.');
      }
    } catch {
      // error
    }
  };

  const updateProducto = async (record) => {
    setData(record);
    setButtontext('Actualizar');
    setTitlemodal('Modificar configuraciones del Producto');
    setUpdate(true);
    setVisible(true);
    const newValues = {
      ...record
    };
    if (record.fecha_inicio) {
      newValues.fecha_inicio = moment(record.fecha_inicio);
    }
    if (record.fecha_fin) {
      newValues.fecha_fin = moment(record.fecha_fin);
    }
    handleActivo(!!record.activo);
    handlePublico(!!record.publico);
    form.setFieldsValue(newValues);
  };

  const handleAsignar = async () => {
    const response = await instanceRef.instance.post(
      `/aseguradoraproducto/searchproducto`,
      {
        id_aseguradora: aseguradoraId,
        id_producto: productoId
      }
    );
    if (response.data.data) {
      message.warning('La aseguradora ya posee el producto Activo');
    } else {
      setButtontext('Asignar');
      setTitlemodal('Configuracion del Producto');
      setActivo(true);
      setVisible(true);
    }
  };

  function getProductoId(id) {
    if (id > 0) {
      setProductoId(id);
      if (aseguradoraId > 0) {
        setHabilitado(true);
      }
    } else {
      setHabilitado(false);
    }
  }

  return (
    <ResponsiveContainer size="large">
      <Card title="Configuración de productos" style={{ textAlign: 'left' }}>
        <Form form={formAseguradora} layout="vertical" style={styles.form}>
          <Form.Item label="Producto" name="producto">
            <AseguradoraProductos getProductoId={getProductoId} />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              disabled={!habilitado}
              onClick={handleAsignar}
            >
              Asignar
            </Button>
          </Form.Item>
        </Form>

        <br />
        <TableAndFilters
          ref={tableRef}
          url={url}
          title="Productos de la Aseguradora"
          columns={columns}
          showTable
        />
      </Card>
      <Modal
        title={titlemodal}
        open={visible}
        width={700}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel} disabled={loading}>
            Cancelar
          </Button>,
          <Button
            key="ok"
            type="primary"
            onClick={handleOk}
            disabled={buttonstate}
            loading={loading}
          >
            {buttontext}
          </Button>
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          name="usuarioForm"
          style={styles.form}
        >
          <Row gutter={8}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Fecha de inicio de Vigencia"
                name="fecha_inicio"
                rules={[{ validator: checkDate }]}
              >
                <CustomDatePicker
                  style={{ width: 'auto' }}
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Fecha de fin de Vigencia"
                name="fecha_fin"
                rules={[{ validator: checkDate }]}
              >
                <CustomDatePicker
                  style={{ width: 'auto' }}
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={24}>
              <Form.Item label="Link de condiciones" name="link_condiciones">
                <Input placeholder="Ingrese link de condiciones" />
              </Form.Item>
            </Col>
            <Col xs={24} md={24}>
              <Form.Item label="Condiciones" name="condiciones">
                <Input.TextArea placeholder="Ingrese las condiciones del producto" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Activo"
                name="activo"
                rules={[{ required: true }]}
              >
                <Switch
                  checkedChildren="Activo"
                  unCheckedChildren="Inactivo"
                  type="primary"
                  onChange={handleActivo}
                  checked={activo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Uso"
                name="publico"
                rules={[{ required: true }]}
              >
                <Switch
                  checkedChildren="Público"
                  unCheckedChildren="Interno"
                  type="primary"
                  onChange={handlePublico}
                  checked={publico}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Monto Cúmulo"
                name="monto_cumulo_gs"
                normalize={(value) => currencyToNumber(value, monedaGs)}
              >
                <CurrencyInputCustom
                  moneda={monedaGs}
                  autoFocus
                  bordered
                  // disabled={rowInicial}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Monto Cúmulo"
                name="monto_cumulo_usd"
                normalize={(value) => currencyToNumber(value, monedaUsd)}
              >
                <CurrencyInputCustom
                  moneda={monedaUsd}
                  autoFocus
                  bordered
                  // disabled={rowInicial}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Fórmula"
                name="formula"
                rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Space>
                    <Radio value={1}>1</Radio>
                    <Radio value={2}>2</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Costo de Servicio (%)"
                name="costo_servicio_porcentaje"
                rules={[{ required: true }]}
              >
                <InputNumber min={0} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Gastos administrativos (%)"
                name="gastos_administrativos"
                rules={[{ required: true }]}
              >
                <InputNumber min={0} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Gastos de cobranza (%)"
                name="gastos_cobranzas"
                rules={[{ required: true }]}
              >
                <InputNumber min={0} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Descuento/Recargo técnico (%)"
                name="descuentos_recargos_tecnicos"
                rules={[{ required: true }]}
              >
                <InputNumber min={-100} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Descuento/Recargo administrativo (%)"
                name="descuentos_recargos_administrativos"
                rules={[{ required: true }]}
              >
                <InputNumber min={-100} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Comisión (%)"
                name="comision"
                rules={[{ required: true }]}
              >
                <InputNumber min={0} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Tasa de interés"
                name="tasa_interes"
                rules={[{ required: true }]}
              >
                <InputNumber min={0} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="IVA (%)"
                name="iva"
                rules={[{ required: true }]}
              >
                <InputNumber min={0} max={100} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Utilidad (%)"
                name="utilidad"
                rules={[{ required: true }]}
              >
                <InputNumber min={0} max={100} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </ResponsiveContainer>
  );
}
export default AseguradoraProducto;
